export default __webpack_public_path__ + "media/images/6-dogs-spaced-38ced85725f43db5762a41640fbe79ad.png";